import { NetworkInfo, UnitConfig } from './types';
import BigNumber from 'bignumber.js';

export const NETWORKS: NetworkInfo[] = [
  { 
    name: 'Solana', 
    symbol: 'SOL', 
    coingeckoId: 'solana'
  }
];

export const UNITS: Record<string, UnitConfig> = {
  sol: {
    label: 'SOL',
    powerNotation: '1,000,000,000,000,000 (10^15)',
    conversionFactor: new BigNumber('1000000000000000'),
    isMainUnit: true,
    showByDefault: true
  },
  lamports: {
    label: 'lamports',
    powerNotation: '1,000,000 (10^6)',
    conversionFactor: new BigNumber('1000000'),
    showByDefault: true
  },
  microlamports: {
    label: 'micro-lamports',
    powerNotation: '1 (10^0)',
    conversionFactor: new BigNumber('1'),
    showByDefault: true
  }
};

export const CONFIG = {
  name: 'Solana Unit Converter',
  description: 'Convert between SOL, Lamports, and Micro-Lamports',
  networks: NETWORKS,
  units: UNITS,
  defaultNetwork: NETWORKS[0]
}; 